"use strict";

var _regeneratorRuntime = require("/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/createClass.js");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.promise");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _SumoLogger = _interopRequireDefault(require("./SumoLogger"));

var _detectBrowser = require("detect-browser");

var _requestor = _interopRequireDefault(require("./requestor"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Logger = /*#__PURE__*/function () {
  function Logger(endpoint, interval, version) {
    _classCallCheck(this, Logger);

    this.endpoint = endpoint;
    this.interval = interval;
    this.version = version ? version : '';
    this.environment = this.getEnvironment();

    try {
      this.userAgent = window.navigator.userAgent;
    } catch (_unused) {
      this.userAgent = '';
    }

    try {
      // @ts-ignore This is an optional dependency a front end may chose to have.
      // Should be configured by the Tracking library to have this on the global scope.
      this.sessionId = window.tracking.visit();
    } catch (_unused2) {
      this.sessionId = '';
    }

    try {
      this.url = window.location.href;
    } catch (_unused3) {
      this.url = '';
    }

    try {
      this.requestor = (0, _requestor.default)();
    } catch (_unused4) {
      this.requestor = '';
    }
  }

  _createClass(Logger, [{
    key: "info",
    value: function info(message, loggerConfig) {
      return this.log(message, _objectSpread({
        logLevel: 'INFO'
      }, loggerConfig));
    }
  }, {
    key: "warn",
    value: function warn(message, loggerConfig) {
      return this.log(message, _objectSpread({
        logLevel: 'WARN'
      }, loggerConfig));
    }
  }, {
    key: "error",
    value: function error(message, loggerConfig) {
      return this.log(message, _objectSpread({
        logLevel: 'ERROR'
      }, loggerConfig));
    }
  }, {
    key: "flushLogs",
    value: function flushLogs() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.getInstance().flushLogs();

              case 3:
                return _context.abrupt("return", _context.sent);

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                console.log("[".concat(_this.requestor, "] Error flushing logs: "), _context.t0);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6]]);
      }))();
    }
  }, {
    key: "log",
    value: function log(message, loggerConfig) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var objectMessage, metadata, logLevel, includeMetadata, contextData;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                objectMessage = {};
                _context2.prev = 1;

                if (!Logger.logsDisabled()) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                objectMessage['message'] = message;
                objectMessage['level'] = 'INFO';
                metadata = true;

                if (loggerConfig) {
                  logLevel = loggerConfig.logLevel, includeMetadata = loggerConfig.includeMetadata, contextData = loggerConfig.contextData;

                  if (logLevel !== null && logLevel !== undefined) {
                    objectMessage['level'] = logLevel;
                  }

                  if (includeMetadata != undefined) {
                    metadata = includeMetadata;
                  }

                  if (contextData) {
                    objectMessage['contextData'] = contextData;
                  }
                }

                if (metadata === true) {
                  objectMessage['environment'] = _this2.environment;
                  objectMessage['user-agent'] = _this2.userAgent;
                  objectMessage['requestor'] = _this2.requestor;
                  objectMessage['version'] = _this2.version;
                }

                if (!Logger.isDevelopment()) {
                  _context2.next = 12;
                  break;
                }

                if (Logger.devLogsEnabled()) {
                  console.log('DEV ENV: ', objectMessage);
                }

                return _context2.abrupt("return");

              case 12:
                _context2.next = 14;
                return _this2.getInstance().log(objectMessage, {
                  url: _this2.url,
                  sessionId: _this2.sessionId
                });

              case 14:
                return _context2.abrupt("return", _context2.sent);

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](1);
                delete objectMessage['contextData'];
                console.error("'".concat(objectMessage['message'], "' contextData could not be completely logged to Sumo"), _context2.t0);
                _context2.prev = 21;
                _context2.next = 24;
                return _this2.getInstance().log("".concat(objectMessage, " (contextData was removed)"), {
                  url: _this2.url,
                  sessionId: _this2.sessionId
                });

              case 24:
                return _context2.abrupt("return", _context2.sent);

              case 27:
                _context2.prev = 27;
                _context2.t1 = _context2["catch"](21);
                console.error("'".concat(objectMessage['message'], "' could not be logged to Sumo"), _context2.t1);

              case 30:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 17], [21, 27]]);
      }))();
    }
  }, {
    key: "getEnvironment",
    value: function getEnvironment() {
      var environment = (0, _detectBrowser.detect)();
      var environmentName = environment && environment.name ? environment.name : 'unknown';
      var environmentVersion = environment && environment.name && environment.version ? environment.version : '';
      var environmentOS = environment && environment.os ? environment.os : 'unknown';
      return "".concat(environmentName, " ").concat(environmentVersion, " - OS ").concat(environmentOS);
    }
  }, {
    key: "getInstance",
    value: function getInstance() {
      var _this3 = this;

      if (!this.sumoLogger) {
        var options = {
          endpoint: this.endpoint,
          interval: this.interval
        };
        this.sumoLogger = new _SumoLogger.default(options);

        try {
          window.addEventListener('beforeunload', function () {
            if (_this3.sumoLogger !== null) {
              try {
                _this3.sumoLogger.flushLogs();
              } catch (e) {// could not flush        
              }
            }
          });
        } catch (e) {// window not found
        }
      }

      return this.sumoLogger;
    }
  }], [{
    key: "getEnvironmentVariable",
    value: function getEnvironmentVariable(variableName) {
      // tslint:disable-next-line
      return typeof process === "undefined" || !process.env ? undefined : process.env[variableName];
    }
  }, {
    key: "isDevelopment",
    value: function isDevelopment() {
      return Logger.getEnvironmentVariable('NODE_ENV') === 'development';
    }
  }, {
    key: "devLogsEnabled",
    value: function devLogsEnabled() {
      return Logger.getEnvironmentVariable('ENABLE_DEV_LOGS') === 'true';
    }
  }, {
    key: "logsDisabled",
    value: function logsDisabled() {
      return Logger.getEnvironmentVariable('DISABLE_LOGS') === 'true';
    }
  }]);

  return Logger;
}();

exports.default = Logger;
module.exports = exports.default;